import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import { getContentfulImageURL } from '../../../../../../utils/general'
import { ShareLinks } from '../share-links'

const ShareCardPreview = observer(() => {
    const {uiStore: {home__share__activeOrg}} = useStore();


    return (
        <div className='share-preview'>
            <div className="flex--center img-container">
                {/* <img src={getContentfulImageURL(data.caseStudyPageLandingImage?.file.url) } alt="" /> */}
        
                <img src={getContentfulImageURL(home__share__activeOrg.shareCardImage?.file.url, 1400, 90)} alt="" />
            </div>
            

            <ShareLinks/>

            <style jsx>{`
                img {
                    width: 800px;
                    height: 419px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .img-container {
                        padding: 0 30px;
                        position: relative;
                        height: 0;
                        padding-bottom: 56.25%;
                        width: 100%;
                    }
                    img {
                        width: 100%;
                        height: auto;
                        position: absolute;
                        top: 0;
                        left: 30px;
                        width: calc(100% - 60px);
                    }
                }
            `}</style>
        </div>
    )
})

export default ShareCardPreview